import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';

const Projects = ({ openGallery, staggerContainer, staggerItem }) => {
  return (
    <section id="projects" className="py-20 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-16">
          <span className="underline-3d">Vybrané projekty</span>
        </h2>
        
        <motion.div 
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
          className="grid grid-cols-1 md:grid-cols-2 gap-10"
        >
          {portfolioData.projects.map((project, index) => (
            <motion.div 
              key={index}
              variants={staggerItem}
              className="group bg-white dark:bg-gray-800 rounded-3xl overflow-hidden shadow-2xl border border-gray-200 dark:border-gray-700/50 hover:border-blue-600/30 transition-all duration-500 hover:shadow-blue-600/10 flex flex-col"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="flex gap-4">
                    {project.hasGallery && (
                      <button 
                        onClick={() => openGallery(project.galleryId)}
                        className="p-3 bg-gray-900 dark:bg-white text-blue-600 rounded-full hover:scale-110 transition-transform shadow-xl aria-label='Open Gallery'"
                      >
                        <Icon icon="mdi:camera-burst" className="text-2xl" />
                      </button>
                    )}
                    <a 
                      href={project.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="p-3 bg-blue-600 text-white rounded-full hover:scale-110 transition-transform shadow-xl aria-label='Live Demo'"
                    >
                      <Icon icon="mdi:link-variant" className="text-2xl" />
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 group-hover:text-blue-600 transition-colors">
                  {project.title}
                </h3>
                <div className="text-gray-600 dark:text-gray-400 mb-6 flex-grow">
                  {project.description}
                </div>
                
                <div className="flex flex-wrap gap-2 pt-4 border-t border-gray-200 dark:border-gray-700/50">
                  {project.tech.map((t, ti) => (
                    <div key={ti} className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 dark:bg-gray-700/50 text-xs font-semibold text-gray-700 dark:text-gray-400 rounded-lg border border-gray-200 dark:border-gray-700">
                      <Icon icon={t.icon} className="text-lg" style={{ color: t.color }} />
                      <span>{t.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
